export default __webpack_public_path__ + "static/Joachim-Godet-689f2094e6cb379cf79f4f6b849334f6.png";